module.exports = __webpack_public_path__ + "img/twitter-icon.e73efc6e.svg";